import SelectCatalogButton from 'components/SelectCatalogButton/SelectCatalogButtonContainer';
import React from 'react';
import { CatalogEntry } from 'typings/models';
import { SelectCatalogEntryButtonListProps } from './SelectCatalogEntryButtonList.types';

export const SelectCatalogEntryButtonList: React.FC<SelectCatalogEntryButtonListProps> = ({
  entity,
  entityType,
  editMode,
  onSaveEntityField,
  onFindCatalogEntry,
}) => {
  const entityName = entityType.toLowerCase() + 's';
  const getEntriesOnDelete = (entry: CatalogEntry) =>
    (entity.catalog_entries?.filter((item) => item.id !== entry.id) ?? []).map((item) => item.id);

  const getEntriesOnClick = (entry: CatalogEntry) => [
    ...(entity.catalog_entries ?? []).filter((item) => item.id !== entry.id).map((item) => item.id),
    entry.id,
  ];

  const editEntriesOnClick = (newEntry: CatalogEntry, oldEntryId) => {
    entity.catalog_entry = newEntry.id;
    const result = [
      ...(entity.catalog_entries ?? [])
        .filter((item) => item.id !== oldEntryId && item.id !== newEntry.id)
        .map((item) => item.id),
      newEntry.id,
    ];
    return result;
  };

  return (
    <tr style={!editMode && entity.catalog_entries?.length === 0 ? { display: 'none' } : {}}>
      <th>{(entity.catalog_entries?.length ?? 0) > 1 ? 'Katalogeinträge' : 'Katalogeintrag'}</th>
      <td>
        <div className="catalog-button-entry-list">
          <div>
            {entity.catalog_entries?.map((entry, key) => (
              <div data-entry-id={entry.id} key={key} style={{ marginBottom: 4 }}>
                <SelectCatalogButton
                  editable={editMode}
                  catalogEntryId={entry.id}
                  onDelete={() =>
                    onSaveEntityField({
                      entity_id: entity.id,
                      entity_name: entityName,
                      fieldname: 'catalog_entries',
                      value: getEntriesOnDelete(entry),
                    })
                  }
                  onClick={() =>
                    onFindCatalogEntry(
                      (newEntry) =>
                        onSaveEntityField({
                          entity_id: entity.id,
                          entity_name: entityName,
                          fieldname: 'catalog_entries',
                          value: editEntriesOnClick(newEntry, entry.id),
                        }),
                      entityType,
                      entry.id
                    )
                  }
                />
              </div>
            ))}
          </div>
          {editMode && (
            <button
              onClick={() =>
                onFindCatalogEntry(
                  (entry) =>
                    onSaveEntityField({
                      entity_id: entity.id,
                      entity_name: entityName,
                      fieldname: 'catalog_entries',
                      value: getEntriesOnClick(entry),
                    }),
                  entityType
                )
              }
              className="add-button"
            >
              Katalogeintrag hinzufügen
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};
